import { useAuth } from "@/composables/useAuth";
import { useMaintenance } from "@/composables/useMaintenance";
import { useParameters } from "@/composables/useParameters";
import Session from "supertokens-web-js/recipe/session";

export const http = {
    get: request("GET"),
    post: request("POST"),
    put: request("PUT"),
    delete: request("DELETE"),
};

function request(method) {
    return async (url, body, options) => {
        const requestOptions = {
            method,
            headers: {},
        };
        if (body) {
            if (body instanceof FormData) {
                requestOptions.body = body;
            } else {
                body = unref(body);
                for (const key of Object.keys(body)) {
                    body[key] = unref(body[key]);
                }

                requestOptions.headers["Content-Type"] = "application/json";
                requestOptions.body = JSON.stringify(body);
            }
        }

        const response = await fetch(`/api${url}`, requestOptions);
        return await handleResponse(response, options);
    };
}

// helper functions
function extractData(response) {
    const jsonTypes = ["application/json"];
    const bufferTypes = ["application/pdf"];

    const contentType = response.headers.get("content-type");
    if (!contentType) {
        return response.text();
    }

    const responseType = contentType.split(";")[0];
    if (jsonTypes.includes(responseType)) {
        return response.json();
    } else if (bufferTypes.includes(responseType)) {
        return response.blob();
    }

    return response.text();
}

let errorToast = null;
async function handleResponse(response, options) {
    const data = await extractData(response);

    // check for error response
    if (!response.ok && !options?.expectError) {
        // Handle maintenance mode (503 Service Unavailable)
        if (response.status === 503) {
            // Check if it's maintenance mode or try to parse the data
            let isMaintenanceMode = false;

            if (typeof data === "object" && data?.code === "MAINTENANCE_MODE") {
                isMaintenanceMode = true;
            } else if (typeof data === "string" && data.includes("MAINTENANCE_MODE")) {
                isMaintenanceMode = true;
            }

            if (isMaintenanceMode) {
                // Set maintenance mode flag and redirect to maintenance page
                const { setMaintenanceMode } = useMaintenance();
                setMaintenanceMode(true);
                if (window.location.pathname !== "/maintenance") window.location.href = "/maintenance";
                return Promise.reject("MAINTENANCE_MODE");
            }
        }

        const { authStore, logout } = useAuth();
        if ([401, 403].includes(response.status) && authStore.isConnected) {
            // try to refresh session else logout
            if (!(await Session.attemptRefreshingSession())) {
                logout();
                // TODO: afficher erreur pour reessayer
            }
        }

        let error = "";

        if (response.status === 400) {
            error = "Veuillez vérifier les informations saisies";

            // In non-production, show celebrate validation details
            const { get } = useParameters();
            if (get("ENV") !== "production" && data?.validation) {
                const validationSource = Object.keys(data.validation)[0];
                const validationDetails = data.validation[validationSource];
                if (validationDetails?.message) {
                    error += `\n\n${validationDetails.message}`;
                }
            }
        } else if (response.status === 413) {
            error = "L'image sélectionnée est trop volumineuse";
        } else if (response.status >= 500) {
            error = "Si l'erreur persite, merci de contacter un administrateur";
        }

        errorToast?.clear();
        errorToast = toast.error({
            title: "Une erreur est survenue",
            message: error,
        });

        return Promise.reject(error);
    }

    return data;
}
